var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 10.25,
    stroke: "#AD2120",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7C9.68629 7 7 9.68629 7 13",
    stroke: "#AD2120",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.318 11.234V11.332H15.13V11.906H14.276C14.2247 12.2187 14.1267 12.4683 13.982 12.655C13.842 12.837 13.6413 12.97 13.38 13.054C13.1187 13.1333 12.7803 13.173 12.365 13.173V13.614C12.365 13.8707 12.4187 14.0737 12.526 14.223C12.638 14.3723 12.8247 14.447 13.086 14.447C13.562 14.447 13.8 14.1787 13.8 13.642H14.535C14.5303 14.1133 14.402 14.4703 14.15 14.713C13.9027 14.951 13.5433 15.07 13.072 15.07C12.6007 15.07 12.239 14.9393 11.987 14.678C11.7397 14.4167 11.616 14.0503 11.616 13.579V12.62C12.134 12.62 12.5143 12.606 12.757 12.578C12.9997 12.5453 13.1793 12.48 13.296 12.382C13.4173 12.284 13.4967 12.1253 13.534 11.906H11.322V11.332H13.569V11.234V10.709H11.322V10.128H15.13V10.709H14.318V11.234Z",
    fill: "#AE2121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4767 16L12.263 18.7391L15.0025 20.9522",
    stroke: "#AE2121",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepayment);
export default __webpack_public_path__ + "static/media/Repayment.7589ed41a8e7de555b198a67e1b6cb70.svg";
export { ForwardRef as ReactComponent };